<template>
  <div class="gf-field-compound">
    <FormSelect v-model="componentValue" :options="options || []" :optional="true" matchField="uuid" />
  </div>
</template>

<script>
import { componentMixin } from '../Form/FormCommon'
import api from '@/Util/api'

export default {
  props: ["placeholder", "item", "field", "dbfield"],
  mixins: [componentMixin],
  data: ()=>({
    options: [],
  }),
  methods: {
    mapItem(item) {
//       console.log(item);
      return {
        text: item.title || item.name,
        value: item,
      }
    },
    async loadOptions(type) {
      this.options=[];
      this.options=(await api.list(this.dbfield.target)).map(this.mapItem);
    },
  },
  created() {
    this.loadOptions();
  },
}
</script>
